import { render, staticRenderFns } from "./WarningLogs.vue?vue&type=template&id=41530561"
import script from "./WarningLogs.vue?vue&type=script&lang=js"
export * from "./WarningLogs.vue?vue&type=script&lang=js"
import style0 from "./WarningLogs.vue?vue&type=style&index=0&id=41530561&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports